import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table } from "flowbite-react";
import { FaEye, FaPause, FaPlay, FaArchive } from "react-icons/fa";
import DeleteModal from "./DeleteModal";
import DateFormatter from "../dates/DateFormatter";
import PlayConfirmationModal from "./PlayConfirmationModal";
import PauseConfirmationModal from "./PauseConfirmationModal";

const CampaignRow = ({ campaign, fetchCampaigns }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openPlayModalConfiration, setOpenPlayModalConfirmation] = useState(false);
  const [openPauseModalConfirmation, setOpenPauseModalConfirmation] = useState(false);

  return (
    <Table.Row key={campaign._id} className="bg-white">
      <Table.Cell>
        <Link
          to={`/campaigns/${campaign._id}`}
          className="text-gray-900 hover:underline font-medium"
        >
          {campaign.name}
        </Link>
      </Table.Cell>
      <Table.Cell>{campaign?.brandId?.name}</Table.Cell>
      <Table.Cell className="capitalize">{campaign.status}</Table.Cell>
      <Table.Cell>
        <DateFormatter date={campaign.createdAt} />
      </Table.Cell>
      <Table.Cell className="flex gap-2 items-center">
        <Button
          as={Link}
          to={`/campaigns/${campaign._id}/view`}
        >
          <FaEye />
        </Button>
        {['paused', 'ended', 'draft'].includes(campaign.status) ? (
          <Button onClick={() => setOpenPlayModalConfirmation(true)}>
            <FaPlay />
          </Button>
        ) : (
          <Button onClick={() => setOpenPauseModalConfirmation(true)}>
            <FaPause />
          </Button>
        )}
        <Button color="failure" onClick={() => setOpenModal(true)}>
          <FaArchive />
        </Button>
        {openModal && (
          <DeleteModal
            campaign={campaign}
            fetchCampaigns={fetchCampaigns}
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
        )}
        {openPlayModalConfiration && (
          <PlayConfirmationModal
            setOpenModal={setOpenPlayModalConfirmation}
            openModal={openPlayModalConfiration}
            campaign={campaign}
            fetchCampaigns={fetchCampaigns}
          />
        )}
        {openPauseModalConfirmation && (
          <PauseConfirmationModal
            setOpenModal={setOpenPauseModalConfirmation}
            openModal={openPauseModalConfirmation}
            campaign={campaign}
            fetchCampaigns={fetchCampaigns}
          />
        )}
      </Table.Cell>
    </Table.Row>
  );
}

export default CampaignRow;
